import { render, staticRenderFns } from "./AgencySettings_Form.vue?vue&type=template&id=20c60d5a&scoped=true"
import script from "./AgencySettings_Form.vue?vue&type=script&lang=js"
export * from "./AgencySettings_Form.vue?vue&type=script&lang=js"
import style0 from "./AgencySettings_Form.vue?vue&type=style&index=0&id=20c60d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c60d5a",
  null
  
)

export default component.exports